import { render, staticRenderFns } from "./VisitFieldTags.vue?vue&type=template&id=1a74f19b&"
import script from "./VisitFieldTags.vue?vue&type=script&lang=js&"
export * from "./VisitFieldTags.vue?vue&type=script&lang=js&"
import style0 from "./VisitFieldTags.vue?vue&type=style&index=0&id=1a74f19b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports